import { Smartphone } from "lucide-react";

/**
 * De dónde vino: de la app del paciente o del mostrador.
 *
 * Solo se pinta cuando vino de la APP. Marcar también lo del mostrador sería
 * poner una etiqueta en casi todas las filas, y una etiqueta que sale siempre
 * deja de verse — justo lo contrario de lo que se busca aquí, que es distinguir
 * de un vistazo lo que llegó solo de lo que costó una llamada.
 *
 * Va en azul de marca y no en verde ni en rojo: no es un estado ni un aviso,
 * es una procedencia. Los colores semánticos son para lo que hay que hacer.
 */
export function EtiquetaOrigen({ origen }: { origen?: string | null }) {
  if (origen !== "APP") return null;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-medium text-sky-700 ring-1 ring-inset ring-sky-200"
      title="El paciente lo hizo desde su app"
    >
      <Smartphone className="h-3 w-3" aria-hidden="true" />
      App
    </span>
  );
}
